var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isDesign
    ? _c(
        "div",
        {
          staticClass: "ds-control ds-lazy-box ds-no-padding",
          class: _vm.getCss,
        },
        [
          _c(
            "div",
            {
              staticClass: "ds-lazy-box-inner",
              attrs: { "slot-name": "default" },
            },
            [_vm._t("default")],
            2
          ),
        ]
      )
    : _vm.support
    ? _c(
        "transition-group",
        {
          staticClass:
            "ds-control ds-lazy-box ds-no-padding ds-lazy-box_support",
          class: _vm.getCss,
          style: _vm.getStyle,
          attrs: { tag: _vm.tagName, name: "lazy-component" },
          on: {
            "before-enter": _vm.beforeEnterHandler,
            "before-leave": _vm.beforeLeaveHandler,
            "after-enter": _vm.afterEnterHandler,
            "after-leave": _vm.afterLeaveHandler,
          },
        },
        [
          _vm.useDefaultSlot
            ? [
                _vm.inClient
                  ? _c(
                      "div",
                      { key: "component", class: _vm.$innerClass },
                      [_vm._t("default", null, { loading: _vm.loading })],
                      2
                    )
                  : _vm.$slots.skeleton
                  ? _c("div", { key: "skeleton" }, [_vm._t("skeleton")], 2)
                  : _vm._e(),
              ]
            : [
                _vm.inClient
                  ? _vm._t("default", null, { loading: _vm.loading })
                  : _vm._e(),
              ],
        ],
        2
      )
    : _c(
        "div",
        { staticClass: "ds-control ds-lazy-box ds-no-padding" },
        [_vm._t("default")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }